<script>
export default {
  data () {
    return {
      years: [],
    }
  },

  computed: {
    electionYear: {
      get () {
        return this.$store.state.databaseSearch.electionYear;
      },
      set (value) {
        this.$store.commit('databaseSearch/setElectionYear', value);
      }
    },
    graphql () {
      return `{
        elections(years:true) {
          edges {
            node {
              year
            }
          }
        }
      }`
    }
  },

  mounted () {
    const self = this;
    self.setYears();
    self.electionYear = self.paramToInt(this.$route.query.electionYear);
  },

  destroyed () {
    const self = this;
    self.$store.commit('databaseSearch/clearElectionFacets');
  },

  methods: {
    paramToInt (param) {
      if (!!parseInt(param)) {
        return parseInt(param);
      }
      else {
        return "";
      }
    },
    setYears () {
      const self = this;
      if ( !!localStorage.electionYears ) {
        self.years = JSON.parse(localStorage.getItem('electionYears'));
      } else {
        self.$http.post(self.$store.state.databaseSearch.endpoint, { query: self.graphql }).then(
          // Success
          response => {
            let years = response.data.data.elections.edges;
            localStorage.setItem('electionYears', JSON.stringify(years));
            self.years = years;
          },
          // Failure
          response => {
            // TODO: handle error
          }
        )
      }
    }
  }
}
</script>

<template lang="html">
  <div class="DatabaseSearch-facets u-mt3">
    <div class="DatabaseSearch-facets-col1">
      <label for="database-election-year">Election Year</label>
      <div class="js-custom-select">
        <select id="database-election-year" v-model="electionYear">
          <option value="">Select</option>
          <option v-for="(item, index) in years" v-bind:value="item.node.year">{{ item.node.year }}</option>
        </select>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// election-facets.vue?392ba8aa